export default "<!--<div class=\"dialog-bg\"></div>-->\n<ng-template #container>\n\n\n</ng-template>\n\n"